export default "<app-dialog title=\"Confirm\" [actionButtons]=\"actionButtons\">\r\n  <div>{{ message }}</div>\r\n</app-dialog>"